import { BASE_URL_LEGACY } from "./";

export const passwordService = {
  sendRecoveryEmail,
  setPassword,
  setPasswordWithToken,
};

function setPassword(current_password, new_password, csrf) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "X-CSRFToken": JSON.parse(localStorage.getItem("CSRF")),
    },
    body: `current_password=${current_password}&new_password=${new_password}`,
    credentials: "include",
  };

  return fetch(`${BASE_URL_LEGACY}/accounts/change_password/`, requestOptions)
    .then((response) => {
      return handleResponse(response);
    })
    .then((detail) => {
      return detail;
    });
}

function setPasswordWithToken(token, new_password) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "X-CSRFToken": JSON.parse(localStorage.getItem("CSRF")),
    },
    body: `new_password=${new_password}&token=${token}`,
    credentials: "include",
  };

  return fetch(`${BASE_URL_LEGACY}/accounts/change_password/`, requestOptions)
    .then((response) => {
      return handleResponse(response);
    })
    .then((detail) => {
      return detail;
    });
}

function sendRecoveryEmail(email) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "X-CSRFToken": JSON.parse(localStorage.getItem("CSRF")),
      credentials: "include",
    },
    body: new URLSearchParams({
      email: email,
    }),
  };

  return fetch(`${BASE_URL_LEGACY}/accounts/reset_password/`, requestOptions)
    .then((response) => {
      return handleResponse(response);
    })
    .then((detail) => {
      return detail;
    });
}

function handleResponse(response) {
  if (!response.ok) {
    return Promise.reject(response.statusText);
  }

  return response.json();
}
